
import { Component, Vue } from 'vue-property-decorator';

import Form10ProcessHeader from "@/components/process/Form10/components/Form10ProcessHeader.vue";
import Form10CaseInformation from "@/components/process/Form10/components/Form10CaseInformation.vue";
import { form10StatusInfoType } from '@/types/Information/Form10';

@Component({
    components:{
        Form10ProcessHeader,
        Form10CaseInformation
    }
})
export default class StartForm10 extends Vue {

    stepsCompleted = {} as form10StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
